import type { GraphNode, GraphNodeType } from "@mind/contracts/browser";
import type { DocumentsSearch } from "../../features/documents/searchState.js";
import type { FocusSearch } from "../../features/focus/searchState.js";
import type { GraphSearch } from "../../features/graph/searchState.js";
import type { WorkSearch } from "../../features/work/searchState.js";

export type CommandDestination =
  | { readonly to: "/documents"; readonly search: DocumentsSearch }
  | { readonly to: "/focus"; readonly search: FocusSearch }
  | { readonly to: "/graph"; readonly search: GraphSearch }
  | { readonly to: "/work"; readonly search: WorkSearch };

export function destinationForGraphNode(node: Pick<GraphNode, "type" | "id" | "revision">, workspaceId: string): CommandDestination {
  switch (node.type) {
    case "document":
      return { to: "/documents", search: { workspace: workspaceId, document: node.id } };
    case "task":
      return { to: "/work", search: { workspace: workspaceId, task: node.id } };
    case "project":
      return { to: "/work", search: { workspace: workspaceId, project: node.id } };
    case "focus_thread":
      return { to: "/focus", search: { workspace: workspaceId, mode: "active", thread: node.id } };
    case "note":
    case "research_source":
    case "account":
      return {
        to: "/graph",
        search: {
          workspace: workspaceId,
          rootType: node.type,
          rootId: node.id,
          rootRevision: node.revision,
        },
      };
  }
}

export function isGraphNodeType(value: string): value is GraphNodeType {
  return value === "note"
    || value === "project"
    || value === "task"
    || value === "document"
    || value === "focus_thread"
    || value === "research_source"
    || value === "account";
}
